
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/job/list/[[...slug]]",
      function () {
        return require("private-next-pages/[locale]/job/list/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/job/list/[[...slug]]"])
      });
    }
  